/* eslint-disable react/prop-types */
import React from "react";
import TopBar from "../partials/TopBar";
import ControlPanelTabs from "../partials/ControlPanelTabs";

const ControlPanel = props => {
  return (
    <React.Fragment>
      <TopBar />
      <ControlPanelTabs location={props.location} />
    </React.Fragment>
  );
};

export default ControlPanel;
